/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 07.10.17.
 */

import React from "react";
import PropTypes from "prop-types";
import Schema from "../../../Schema";
import SchemaRegistry from "../../../services/SchemaRegistry";

class BasePageComponent extends React.Component {
    static propTypes = {
        basePath: PropTypes.string.isRequired,
        params: PropTypes.shape({
            path: PropTypes.string.isRequired,
            fieldPath: PropTypes.string.isRequired,
            resource: PropTypes.string.isRequired,
            action: PropTypes.oneOf(["list","new","view","edit","delete"]).isRequired,
            id: PropTypes.string,
            query: PropTypes.object,
            parentPath: PropTypes.string,
            parentFieldPath: PropTypes.string,
            parentResource: PropTypes.string,
            parentAction: PropTypes.oneOf(["list","new","view","edit","delete"]),
            parentId: PropTypes.string,
            parentField: PropTypes.string
        }).isRequired,
        location: PropTypes.object.isRequired,
        router: PropTypes.object.isRequired,
        route: PropTypes.object.isRequired,
        /**
         * UI Schema name assigned to this component
         */
        schema: PropTypes.string.isRequired,
        navSchema: PropTypes.string.isRequired,
        navField: PropTypes.string.isRequired
    };

    static defaultProps = {};

    constructor(props) {
        super(props);
        this.state = {};
    }

    getNavSchema(props) {
        if (!props) props = this.props;
        if (!props.navResource) return null;
        let rootNavSchema = SchemaRegistry.getNavigationSchemaObject(props.navResource);
        return rootNavSchema.field(props.navField);
    }

    /**
     * @abstract
     * @returns {XML}
     */
    render() {
        return (
            <div>
            </div>
        );
    }
}

export default BasePageComponent;
